import {useEffect, useState} from 'react';
import {Breadcrumb, ProgressIndicator} from '@/components/atoms';
import {PageHeader, SaveCancelFooter} from '@/components/molecules';
import {ROUTES} from '@/utils/constants/routesConstants';
import {useNavigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {isVideoActivityType} from '@/types/Activity';
import {getModal} from '@/utils/CommonModal';
import {resetActivityData} from '@/store/slices/activitySlice';
import {useDispatch} from 'react-redux';

/**
 * Video activity step 2 (Display). Setup is on Add Activity; Review follows.
 */
const ActivityDisplay = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isCancel, setIsCancel] = useState(false);
  const {activityType} = useSelector((state) => state.activity.formData) || {};

  const isVideoFlow = isVideoActivityType(activityType);

  useEffect(() => {
    if (activityType && !isVideoActivityType(activityType)) {
      navigate(ROUTES.ACTIVITY_ADD, {replace: true});
    }
  }, [activityType, navigate]);

  const handleCancel = () => setIsCancel(true);

  const onClickPrimaryButton = () => {
    dispatch(resetActivityData({activityType: '', hasEndDate: false}));
    navigate(ROUTES.ACTIVITIES);
  };

  const onClickSecondaryButton = () => setIsCancel(false);

  const handleNext = () => {
    navigate(ROUTES.ACTIVITY_REVIEW);
  };

  if (!isVideoFlow) {
    return null;
  }

  return (
    <>
      <Breadcrumb
        uiSchema={{
          isDark: true,
          className: 'mb-5',
          breadcrumbs: [
            {label: '', href: ROUTES.HOME},
            {label: 'Loyalty Campaigns', href: ROUTES.ACTIVITIES},
            {label: 'Add Activity', href: ROUTES.ACTIVITIES}
          ]
        }}
        id='activity_display_breadcrumb'
      />
      <PageHeader title='Add Activity' />
      <ProgressIndicator
        currentStep={2}
        steps={3}
        titles={[{title: 'Setup'}, {title: 'Display'}, {title: 'Review'}]}
        className='mb-6'
        onStepClick={(step) => {
          if (step === 1) navigate(ROUTES.ACTIVITY_ADD);
          if (step === 3) navigate(ROUTES.ACTIVITY_REVIEW);
        }}
      />
      <div
        className='mb-8 rounded-lg border border-white/10 p-8 text-slate-300'
        data-testid='activity-display-placeholder'>
        <p className='text-base'>
          Display settings for this video activity will be configured here.
        </p>
      </div>
      <SaveCancelFooter
        handleCancel={handleCancel}
        nextAction={handleNext}
        draftAction={() => {}}
        FormError={false}
        hideSaveDraft
        nextButtonTitle='Next'
      />
      {isCancel &&
        getModal({
          title: 'Are you sure you want to cancel?',
          text: 'Your work will not be saved if you click Yes. To continue editing and go back to the page, click NO',
          showPrimaryButton: true,
          primaryButtonText: 'Yes',
          onClickPrimaryButton: onClickPrimaryButton,
          showSecondaryButton: true,
          secondaryButtonText: 'No',
          onClickSecondaryButton: onClickSecondaryButton,
          showModal: isCancel,
          onCloseModal: handleCancel,
          hideCloseButton: false
        })}
    </>
  );
};

export default ActivityDisplay;
